import Button from '@/components/atoms/Button'
import Container from '@/components/atoms/Container'
import Icon from '@/components/atoms/Icon'
import { useLocation, useNavigate } from 'react-router-dom'

export function Topbar() {
	const navigate = useNavigate()
	const location = useLocation()

	const handleNavigation = () => {
		const pathParts = location.pathname.split('/').filter(Boolean)

		if (pathParts.length > 1) {
			// Remove a última parte do caminho e navega para a página pai
			const parentPath = '/' + pathParts.slice(0, -1).join('/')
			navigate(parentPath)
		} else {
			// Se já estiver na rota principal, permanece ou navega para uma rota padrão
			navigate('/curso')
		}
	}

	return (
		<>
			<header className='w-full sticky top-0 z-30 md:py-2 bg-zinc-950'>
				<Container className='w-full !max-w-[1420px] xl:px-8 2xl:px-0 h-[101px] flex items-center justify-between'>
					<div className='flex items-center'>
						<Button
							className='w-full max-w-max h-auto border-solid bg-transparent hover:bg-transparent py-2 rounded-full px-4'
							onClick={handleNavigation}
						>
							<Icon
								name='arrow-left'
								width='20'
								height='20'
								className='text-[#000000]'
							/>
							<p className='ml-3 text-zinc-50'>Voltar</p>
						</Button>
					</div>
				</Container>
			</header>
		</>
	)
}
